export const useStyles = (theme) => ({
  root: {
    display: "flex",
    [theme.breakpoints.down(600)]: {
      flexDirection: "column",
    },
  },
  content: {
    width: "25%",
    marginRight: 5,
    [theme.breakpoints.down(600)]: {
      width: "100%",
    },
  },
});
